var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.286 5.7a.593.593 0 0 0-.586.6v1.9h16.6V6.3c0-.339-.27-.6-.586-.6H4.286ZM20.3 9.6H3.7v7.1c0 .339.27.6.586.6h15.428a.593.593 0 0 0 .586-.6V9.6Zm-18-3.3c0-1.097.882-2 1.986-2h15.428c1.104 0 1.986.903 1.986 2v10.4c0 1.097-.882 2-1.986 2H4.286a1.993 1.993 0 0 1-1.986-2V6.3Zm10.343 8.5H4.928v-1.4h7.715v1.4Zm6.428 0h-3.857v-1.4h3.857v1.4Z"
  })));
};
export { SvgCard as ReactComponent };
export default __webpack_public_path__ + "fb1956704bdda33457932c07e6d97026.svg";